/**
 * Abstract "collaboration / build" illustration for the About section.
 * Layered cards with a connected-nodes motif. Pure inline SVG.
 */
export default function AboutIllustration({ className = '' }) {
  return (
    <svg
      viewBox="0 0 480 420"
      role="img"
      aria-label="Abstract illustration of a team building connected systems"
      className={className}
    >
      <defs>
        <linearGradient id="aboutBlue" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
        <linearGradient id="aboutCard" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#eff6ff" />
        </linearGradient>
        <filter id="aboutShadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="18" stdDeviation="22" floodColor="#1d4ed8" floodOpacity="0.16" />
        </filter>
      </defs>

      <circle cx="380" cy="80" r="66" fill="#dbeafe" />
      <circle cx="90" cy="340" r="48" fill="#bfdbfe" opacity="0.7" />

      {/* big rounded blob */}
      <path
        d="M120 60 C 260 20, 420 70, 420 200 C 420 330, 300 380, 190 360 C 70 340, 40 200, 120 60 Z"
        fill="url(#aboutBlue)"
        opacity="0.08"
      />

      {/* stacked cards */}
      <g filter="url(#aboutShadow)">
        <rect x="150" y="150" width="230" height="150" rx="20" fill="url(#aboutCard)" stroke="#e2e8f0" transform="rotate(-6 265 225)" />
        <rect x="120" y="130" width="230" height="150" rx="20" fill="url(#aboutCard)" stroke="#e2e8f0" />
        <rect x="140" y="158" width="120" height="14" rx="7" fill="#2563eb" opacity="0.85" />
        <rect x="140" y="184" width="190" height="10" rx="5" fill="#cbd5e1" />
        <rect x="140" y="204" width="160" height="10" rx="5" fill="#e2e8f0" />
        <rect x="140" y="238" width="80" height="26" rx="13" fill="url(#aboutBlue)" />
      </g>

      {/* connected nodes */}
      <g className="animate-float">
        <line x1="360" y1="330" x2="410" y2="270" stroke="#93c5fd" strokeWidth="3" />
        <line x1="360" y1="330" x2="300" y2="360" stroke="#93c5fd" strokeWidth="3" />
        <circle cx="360" cy="330" r="16" fill="url(#aboutBlue)" />
        <circle cx="410" cy="270" r="10" fill="#ffffff" stroke="#2563eb" strokeWidth="3" />
        <circle cx="300" cy="360" r="10" fill="#2563eb" />
      </g>
    </svg>
  )
}
